import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useRouteMatch } from "react-router-dom";

import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import {
  fetchLoyaltyProgramInfo,
  fetchNotificationConfigInfo,
} from "../../../../services/customerApp/customerDetails";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import NotificationNode from "./NotificationNode";
import { Box, Hidden } from "@material-ui/core";
import PageHeaderMobile from "../../../../components/common/PageHeader/PageHeaderMobile";
import AlertDialogDefault from "../../../../components/alerts/AlertDialogDefault";

/**
 * BannerListPage Component
 *
 * This component is responsible for rendering a paginated list of customer data.
 * It fetches customer information from an API and allows users to navigate through pages and sort the data.
 */
const BannerListPage: React.FunctionComponent<{}> = () => {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [notificationNode, setNotificationNode] = useState<any>([]);
  const [isOwner, setIsOwner] = useState(false);
  const [isActive, setIsActive] = useState(true);

  const match: any = useRouteMatch();

  const handleGetLocationProgram = async () => {
    try {
      const { data } = await fetchLoyaltyProgramInfo(match.params.locationId);
      const programDetails: any = Object.values(data.data)[0];
      setIsActive(programDetails?.status);
      if (programDetails?.status) {
        setIsOwner(
          programDetails?.owner === match.params.locationId ? true : false,
        );
        handleGetNotificationConfig();
      } else {
        setIsLoading(false);
      }
      return data.data;
    } catch (error) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setIsLoading(false);
    }
  };

  const handleGetNotificationConfig = async () => {
    try {
      const res = await fetchNotificationConfigInfo(match.params.locationId);
      setNotificationNode(res.data.data);
      setIsLoading(false);
    } catch (err) {
      // If there is an error during the API call, set an error message in the state
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    }
    setIsLoading(false);
  };

  /**
   * useEffect Hook
   *
   * This hook is used to perform side effects in the component.
   * In this case, it sets the document title, fetches customer data, and fetches location information.
   */
  useEffect(() => {
    // Set the document title
    document.title = " Loyalty & Customers - Notification URL";

    // Fetch location information
    handleGetLocationProgram();
  }, []);

  return (
    <>
      <Hidden lgUp>
        <PageHeaderMobile />
      </Hidden>
      <Box style={{ marginTop: "18px" }}>
        <NotificationNode
          isLoading={isLoading}
          bannerNode={notificationNode}
          isOwner={isOwner}
        />
      </Box>
      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
      <AlertDialogDefault
        open={!isActive}
        title="Warning"
        desc="Customer loyalty points management is disabled on your account. Please contact your EPOS account manager to request access."
        severity="warning"
        color="secondary"
        disableBackdropClick
      />
    </>
  );
};

export default withAuthority(BannerListPage, Authorities.CUSTOMER_LIST_READ);
